export default "__VITE_ASSET__DEwZyEQt__"